import commonRoutes, {
  bareRoutes,
  isPathToDetails,
  projectBased,
} from '~/client/src/shared/constants/commonRoutes'

export type MobileRoute = keyof typeof mobileRoutes

const mobileRoutes = {
  ...commonRoutes,

  PHOTO_DETAIL: projectBased('/photo/:photoId'),
  FORM_VIEW: projectBased(`${bareRoutes.FORMS}/:formId`),
  DOCUMENTS: '/documents',
  SEND_SMS_DELIVERY_TICKET: '/send-sms-ticket',
  USERS_DIRECTORY: projectBased('/users'),
  QR_CODES: projectBased(bareRoutes.QR_CODES),
  NOTIFICATION_SETTINGS: projectBased(bareRoutes.NOTIFICATION_SETTINGS),
  QR_CODE: projectBased('/qr-code'),
  QR_CODE_ACCESS: projectBased('/qr-code-access/:userId'),
  USER_PROFILE: '/users/:userId',
  CHAT: '/chat',
  ADD_TEAMMATE: projectBased('/add-teammates'),
  SELECT_FORM_TYPE: projectBased('/select-form-type'),
  EQUIPMENT: projectBased(bareRoutes.EQUIPMENT),
  STRUXTAGS: projectBased(bareRoutes.STRUXTAGS),
  MATERIAL_RESOURCES: projectBased(bareRoutes.MATERIAL_RESOURCES),
  LOCATIONS: projectBased(bareRoutes.LOCATIONS),

  ONE_TIME_POPUP: '/one-time-popup',
}

export function isMobileRoute(route): route is MobileRoute {
  return !!mobileRoutes[route]
}

// TODO: Examine it, do we really need it?
export function shouldRedirect(currentPath: string, redirectTo: string) {
  const {
    PROJECTS,
    HOME,
    DELIVERIES,
    SEND_SMS_DELIVERY_TICKET,
    USERS_DIRECTORY,
    FORM_TYPES,
    ADD_TEAMMATE,
    FORMS,
    EQUIPMENT,
    MATERIAL_RESOURCES,
    STRUXTAGS,
    LOCATIONS,
  } = mobileRoutes

  switch (redirectTo) {
    case PROJECTS:
      return ![PROJECTS].some(r => r.includes(currentPath))

    case USERS_DIRECTORY:
    case DELIVERIES:
    case HOME:
    case FORMS:
    case EQUIPMENT:
    case MATERIAL_RESOURCES:
    case STRUXTAGS:
    case LOCATIONS:
      return (
        !isPathToDetails(currentPath) &&
        ![
          FORM_TYPES,
          PROJECTS,
          ADD_TEAMMATE,
          bareRoutes.USERS_DIRECTORY,
          bareRoutes.DELIVERIES,
          bareRoutes.FORMS,
          bareRoutes.NOTIFICATIONS,
          bareRoutes.DOCUMENTS,
          bareRoutes.EQUIPMENT,
          bareRoutes.STRUXTAGS,
          bareRoutes.MATERIAL_RESOURCES,
          bareRoutes.LOCATIONS,
          bareRoutes.QR_CODES,
          bareRoutes.NOTIFICATION_SETTINGS,
          SEND_SMS_DELIVERY_TICKET,
          bareRoutes.HOME,
        ].some(route => currentPath.includes(route))
      )
    case commonRoutes.NOTIFICATIONS:
      return true

    default:
      return false
  }
}

export default mobileRoutes
